import { AppRoutes } from '@/routes/AppRoutes';

/**
 * Application root.
 *
 * Everything it does is delegated: authentication and the guarded route tree come from
 * {@link AppRoutes}, and the shell, navigation and design system are mounted by the layout route
 * inside it. Keeping the root this thin means the providers in main.tsx are the only thing that
 * has to be reproduced by a test that renders the app.
 *
 * @returns the application element
 */
export function App(): React.JSX.Element {
  return <AppRoutes />;
}
